import React from 'react';
import {Grid} from "@mui/material";

import './../../Styles/globals.css'
import './../../Styles/drawerCss.css';
import './../../Styles/footerCss.css';

import Footer from "../../components/footer/footer";
import WhatsappLogo from "../sharedTexts/WhatsappLogo";
import NavBarWithoutButtons from "../../components/navbar/navBarWithoutButtons";


interface props {
    children: JSX.Element | JSX.Element[],
    showWinahostLogo: boolean,
    showWinahostFooter: boolean,
}

const BaseWithoutNavBarLayout = ({children, showWinahostLogo = false, showWinahostFooter = false}: props) => {

    return (
        <Grid container>
            {showWinahostLogo && <NavBarWithoutButtons lang={'es'}/>}
            <Grid container mt={showWinahostLogo ? '65.5px' : '0px'} justifyContent="center">
                <Grid item xs={12} className={'MobileScreenLayout'}>
                    {children}
                    <WhatsappLogo/>
                </Grid>
            </Grid>
            {showWinahostFooter && <Footer/>}
        </Grid>
    );
}

export default BaseWithoutNavBarLayout;
